import src from "IMAGE";
export default { src, width: 19, height: 15, blurWidth: 0, blurHeight: 0};
